export const Light = '#2EC5CE'
export const Power = '#8C30F5'
export const PowerHover = '#6622b4'
export const TextColor = '#18191F;'
//export const FORM_BACKGROUND = '#d1acfb'
export const FORM_BACKGROUND = '#D5E0FC'//"#d9e5ff"//
export const GREY_BACKGROUND = '#f9f4fe'

export const DEFAULT_TEMPLATE_ID = 'cbf25ded-a470-4c48-ab35-b0a3f6018594'
